<app-dashboard [trackDashboardId]="dashboardId"></app-dashboard>
